export class DashboardGestao {
  empresas: number;
  processos: number;
  atendimentos: number;
  movimentacao: number;
  acessos: number;
  feedbacks: number;
}
